import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { getTruncationCss } from '../../utils';
import { EInputType, ESuggestType } from '../../../../types';
import { UndergroundLines } from '../UndergroundLines';
import { ItemContent } from '../ItemContent';
import * as styles from '../../styles.css';
import { mergeStyles } from '@cian/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseSuggestionContent = function BaseSuggestionContent(props) {
  var item = props.item,
    inputType = props.inputType,
    itemsTruncation = props.itemsTruncation;
  var isMobile = !(inputType === EInputType.search || inputType === EInputType.mainpage);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [item.type === ESuggestType.underground && /*#__PURE__*/_jsx(UndergroundLines, {
      lines: item.lines,
      isMobile: isMobile
    }), /*#__PURE__*/_jsx("div", {
      className: getTruncationCss(itemsTruncation),
      children: /*#__PURE__*/_jsx("span", {
        className: getTruncationCss(itemsTruncation, true),
        children: /*#__PURE__*/_jsx(ItemContent, {
          item: item
        })
      })
    }), 'address' in item && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['address'], styles['trunc_1'])), {}, {
      children: item.address
    }))]
  });
};